class PortraitChinois{
    links;
    constructor(){
        this.collectAllLinks();
        
    }
    collectAllLinks(){
        this.links = document.querySelectorAll('.ouvrir-portrait-chinois');

        this.links.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const href = link.getAttribute('href');
                this.updateModalTitle();
                this.updateModalContent(href);
            });
        });
    }
    updateModalTitle(title = 'Portrait Chinois'){
        let modalTitle = document.querySelector('#modal-x .modal__title');
        if(!modalTitle){return;}
        modalTitle.textContent = title;
    }
    updateModalContent(href){
        let modalContent = document.querySelector('#modal-x .modal__content');
        if(!modalContent){return;}
        if (!href) {
            modalContent.textContent = 'Aucune URL fournie.';
            return;
        }
        // Add spinner
        modalContent.innerHTML = '<div class="modal__spinner" style="display:flex;justify-content:center;align-items:center;height:80px;"><svg width="32" height="32" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" stroke="#767676" stroke-width="5" stroke-linecap="round" stroke-dasharray="31.4 31.4" transform="rotate(-90 25 25)"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/></circle></svg></div>';
        fetch(href)
            .then(response => {
                if (!response.ok) throw new Error('Erreur AJAX');
                return response.json();
            })
            .then(data => {
                if (data && data.content) {
                    this.updateModalTitle('Portrait chinois');
                    modalContent.innerHTML = data.content;
                } else if (data && data.message) {
                    modalContent.textContent = data.message;
                } else {
                    modalContent.textContent = 'Aucune donnée.';
                }
            })
            .catch(err => {
                modalContent.textContent = 'Erreur lors du chargement.';
            });
    }
    
}

document.addEventListener('DOMContentLoaded',()=>{
    new PortraitChinois();
});